import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { PartnerWelcome } from "assets";
import { useOnboardingNavigation } from "routes/onboarding";
import { BaseButton } from "shared/atoms/BaseButton";
import { BLUE } from "theme/colors";

export const PartnerWelcomePage = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { nextRoute } = useOnboardingNavigation();

  return (
    <OnboardingWelcome>
      <StyledOnboardingImage data-testid="partner-onboarding-welcome-page-img" />

      <Typography variant="h2" mt="16px" mb="16px">
        {t("partner_onboarding.header")}
      </Typography>

      <Stack spacing={2} data-testid="partner-onboarding-welcome-page-body">
        <Stack direction="row" alignItems="baseline" spacing={1}>
          <FontAwesomeIcon icon={faCheck} color={BLUE[100]} />
          <Typography variant="body1" color="textSecondary" textAlign="left">
            {t("partner_onboarding.body1")}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="baseline" spacing={1}>
          <FontAwesomeIcon icon={faCheck} color={BLUE[100]} />
          <Typography variant="body1" color="textSecondary" textAlign="left">
            {t("partner_onboarding.body2")}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="baseline" spacing={1}>
          <FontAwesomeIcon icon={faCheck} color={BLUE[100]} />
          <Typography variant="body1" color="textSecondary" textAlign="left">
            {t("partner_onboarding.body3")}
          </Typography>
        </Stack>
      </Stack>

      <BaseButton
        dataTestID="onboarding-welcome-page-next-btn"
        text={t("buttons.get_started")}
        onClick={() => nextRoute && navigate(nextRoute)}
        icon="check"
        iconPlacement="end"
        style={{ marginTop: "24px" }}
        fullWidth
      />
    </OnboardingWelcome>
  );
};

const OnboardingWelcome = styled.div`
  text-align: center;
`;

const StyledOnboardingImage = styled(PartnerWelcome)`
  height: auto;
  margin-top: 20px;

  ${props => props.theme.belowMobileBreakpoint} {
    max-width: 200px;
    margin-top: auto;
  }
`;
